export default "__VITE_ASSET__BZSIP175__"